module.exports = __webpack_public_path__ + "img/video-player/luna-head-e7402004716fa3eaccfb2ebdd0e8877d.svg";